import React from 'react';

import Slider from '@react-native-community/slider';
import { NEUTRAL_TEXT0 } from '../../config/designSystem/Colors';
import { ParagraphMRegular } from '../../config/designSystem/typography';
import { SLIDER_THUMB_SIZE } from '../../config/designSystem/Spacing';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { isNil } from 'lodash';



function msConversion(millis) {
  let sec = Math.floor(millis / 1000);
  const hrs = Math.floor(sec / 3600);
  sec -= hrs * 3600;
  let min = Math.floor(sec / 60);
  sec -= min * 60;

  sec = '' + sec;
  sec = ('00' + sec).substring(sec.length);

  if (hrs > 0) {
    min = '' + min;
    min = ('00' + min).substring(min.length);
    return hrs + ':' + min + ':' + sec;
  } else {
    return min + ':' + sec;
  }
}
const SeekBar = ({ trackLength,
  currentPosition,
  onSeek,
  onSlidingStart,
  fast,
  onFastRate,
  hideFastRate,
  minimumTrackTintColor,
  maximumTrackTintColor,
  textColor ,
  sliderColor, width}) => {
  const elapsed = msConversion(currentPosition);
  const trackLengthAvailable = !isNil(trackLength) && !!trackLength && trackLength>0;
  const trackLengthToMinutes = msConversion(trackLength - currentPosition);
  const MARGIN= 10;
  const WIDTH_TEXT = Math.max(40, 0.1*width);
  const WIDTH_SLIDER = width- 2*MARGIN - 2*WIDTH_TEXT;
  const TEXT_COLOR = textColor? textColor: NEUTRAL_TEXT0;
  return (
    <View style={styles.container}>
      <View style={{ flexDirection: 'row', alignItems:'center', justifyContent:'space-between' }}>
        <View style={{marginRight:MARGIN, width: WIDTH_TEXT}}>
          <ParagraphMRegular color={TEXT_COLOR} >{elapsed}</ParagraphMRegular>
        </View>
        <Slider
          maximumValue={Math.max(trackLength, 1, currentPosition + 1)}
          onSlidingStart={onSlidingStart}
          onSlidingComplete={onSeek}
          value={currentPosition}
          style={{width: WIDTH_SLIDER}}
          minimumTrackTintColor={minimumTrackTintColor}
          maximumTrackTintColor={maximumTrackTintColor}
          thumbTintColor={sliderColor}
          thumbSize={SLIDER_THUMB_SIZE}
        />


        {trackLengthAvailable && (<View style={{marginLeft:MARGIN, width: WIDTH_TEXT}}>
          <ParagraphMRegular color={TEXT_COLOR} >{trackLengthToMinutes}</ParagraphMRegular>
        </View>)}
      </View>
      <View style={{justifyContent: 'flex-start', alignSelf: 'flex-start'}}>
        {!hideFastRate && <TouchableOpacity onPress={onFastRate}>
          <View style={[styles.playButtonAbsolute, { marginLeft: 20 }]}>
            {fast ? <ParagraphMRegular color={TEXT_COLOR} >x1</ParagraphMRegular> :
              <ParagraphMRegular color={TEXT_COLOR} >x1.2</ParagraphMRegular>}
          </View>
        </TouchableOpacity>
        }
      </View>
    </View>
  );
};

export default SeekBar;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 14,
    flexDirection: 'row'
  },
  playButtonAbsolute: {
    height: 30,
    width: 30,
    // paddingLeft: 8,
    // borderWidth: 1,
    // borderColor: '#444',
    // borderRadius: 72 / 2,
    alignItems: 'center',
    alignSelf: 'flex-end',
    justifyContent: 'center',
    backgroundColor: '#4f9eb5',
    borderRadius: 15,
  },
  text: {
    color: 'rgba(0, 0, 0, 0.72)',
    fontSize: 12,
    textAlign: 'center',
  },
});
